<template>
    <div>
        <div><i class="material-icons">sentiment_very_satisfied</i></div>
        <h3>Export</h3>
        <div style="text-align: left">
            <p>Velg mottaker</p>
        </div>
        <!--
        <div class="inputWrap">
            <input placeholder="Poststed" v-model="contact_city" type="text"/>
            <span class="v-error" v-if="localErrors.contact_city" v-text="localErrors.contact_city"></span>
        </div>
        <div class="inputWrap">
            <input placeholder="Gateadresse" v-model="contact_address" type="text"/>
            <span class="v-error" v-if="localErrors.contact_address" v-text="localErrors.contact_address"></span>
        </div>
        <div class="inputWrap">
            <input placeholder="Postnummer" v-model="contact_zip" type="text"/>
            <span class="v-error" v-if="localErrors.contact_zip" v-text="localErrors.contact_zip"></span>
        </div>
        -->
        <div class="inputWrap">
            <v-select placeholder="Teknikker" v-model="technician" label="name" :options="technicians"></v-select>
            <span class="v-error" v-if="localErrors.technician" v-text="localErrors.technician"></span>
        </div>
        <div class="actions">
            <div>
                <button @click.prevent="close()">Nei</button>
            </div>
            <div>
                <button @click.prevent="send()">Send</button>
            </div>
        </div>
        <div class="mpsCancelBtn" @click.prevent="close()"><i class="material-icons">close</i></div>
    </div>
</template>

<script>

    import VuejsDialogMixin from 'vuejs-dialog/dist/vuejs-dialog-mixin.min.js'; // only needed in custom components

    export default {
        data () {
            return {
                id_technician: null,
                technicians: [],
                contact_address: null,
                contact_city: null,
                contact_zip: null,
                validate: false
            }
        },
        mixins: [VuejsDialogMixin],
        computed: {
            technician: {
                get: function () {
                    for (var i = 0; i < this.technicians.length; i++) {
                        var technician = this.technicians[i];
                        if(technician.id == this.id_technician)
                            return technician
                    }
                    return null
                },
                set: function (technician) {
                    if(technician)
                        this.id_technician = technician.id
                    else
                        this.id_technician = null
                }
            },
            localErrors(){
                if(this.validate){
                    var e = {};
                    /*
                    if(!this.contact_city)
                        e.contact_city = 'Please enter contact city';
                    if(!this.contact_address)
                        e.contact_address = 'Please enter contact address';
                    if(!this.contact_zip.match(/^\d{4}$/ig))
                        e.contact_zip = 'Please enter valid contact zip';
                     */
                    if(!this.technician)
                        e.technician = 'Please select technician';
                    return e;
                }else{
                    return {};
                }
            }
        },
        methods: {
            send(){
                if(!this.validateChanges()) return;
                this.proceed( {
                    id_workshop: this.id_technician,
                    //contact_city: this.contact_city,
                    //contact_zip: this.contact_zip,
                    //contact_address: this.contact_address
                } );
            },
            validateChanges(){
                this.validate = true;

                if(Object.keys(this.localErrors).length)
                    return false;

                return true;
            },
        },
        created(){
            this.technicians = this.$options.propsData.options.technicians;
            //this.contact_address = this.$options.propsData.options.contact_address;
            //this.contact_city = this.$options.propsData.options.contact_city;
            //this.contact_zip = this.$options.propsData.options.contact_zip;
        }
    }
</script>

<style lang="scss">
</style>


// WEBPACK FOOTER //
// ExportDialog.vue?02088cf5